export default __webpack_public_path__ + "static/media/MARCZYNSKI.e7681f55.jpg";